var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"warp"},[_c('div',{staticClass:"artdetail-box"},[_c('div',{staticClass:"artdetail-tit"},[_vm._v(_vm._s(_vm.detailTitle))])]),_c('div',{staticClass:"introduction-content",domProps:{"innerHTML":_vm._s(_vm.detailList)}})])}
var staticRenderFns = []

export { render, staticRenderFns }